import React from 'react';
import { t, useBehaviorSubject } from '@base/utils/helpers';
import { container } from 'tsyringe';
import styles from '../styles/layoutControl.module.scss';
import classNames from 'classnames';
import { FONT_SIZES, THEMES } from '@base/features/theme/interfaces';
import { IThemeService } from '@base/features/theme/themeService';

function LayoutControl() {
  const themeService: IThemeService = container.resolve('themeService');
  const layout = useBehaviorSubject(themeService.layout);

  return (
    <div className={styles.layout}>
      <div className={styles.section}>
        <div className={styles.title}>{t('font_size')}</div>
        <Picker>
          {Object.values(FONT_SIZES).map((size) => (
            <div
              className={classNames(styles.font, {
                [styles.activeFontSize]: size === layout.font,
              })}
              style={{ fontSize: size }}
              onClick={() => themeService.setFontSize(size)}
            >
              a
            </div>
          ))}
        </Picker>
      </div>
      <div className={styles.section}>
        <div className={styles.title}>{t('color')}</div>
        <Picker>
          {Object.values(THEMES).map((theme) => (
            <div
              className={classNames(styles.colorPicker, theme, {
                [styles.activeTheme]: theme === layout.theme,
              })}
              onClick={() => themeService.setColorTheme(theme)}
              key={theme}
            />
          ))}
        </Picker>
      </div>
    </div>
  );
}

function Picker(props: { children: JSX.Element[] }) {
  return <div className={styles.picker}>{props.children}</div>;
}

export default LayoutControl;
